import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSensors } from 'hooks';
import { Typography, Grid } from '@mui/material';

const ProductionReport = () => {
  const { sensors } = useSensors();
  const { t } = useTranslation();

  let availableSensors = sensors?.filter((sensor) => sensor.pcba_id == null)?.length;
  let pcbaSensors = sensors?.filter((sensor) => sensor.pcba_id != null && sensor.spike_id == null)?.length;

  return (
    <Grid container spacing={2} direction={'column'}>
      <Grid item>
        <Typography variant="h4">{t('available_sensors')}</Typography>
        <Typography variant="body1">{availableSensors ? availableSensors : 0}</Typography>
      </Grid>

      <Grid item>
        <Typography variant="h4">{t('pcba_sensors')}</Typography>
        <Typography variant="body1">{pcbaSensors ? pcbaSensors : 0}</Typography>
      </Grid>
    </Grid>
  );
};

export default ProductionReport;
